import React, { useState } from 'react';
import { Copy, Check, HelpCircle } from 'lucide-react';

interface PaypalReturnUrlProps {
  planName: string;
}

export const PaypalReturnUrl: React.FC<PaypalReturnUrlProps> = ({ planName }) => {
  const [copied, setCopied] = useState(false);
  
  // Encode the plan name to ensure it's URL safe
  // We use the exact plan name as requested, encoded for URL safety
  const url = `https://escalable.host/pago?plan=${encodeURIComponent(planName || '')}&estado_pago=exito`;

  const onCopy = () => {
    navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="space-y-1 mt-4">
      <div className="flex items-center gap-1 text-sm font-medium text-gray-700 dark:text-gray-300">
        <span>URL de Retorno Paypal (Automática)</span>
        <span title="Copia esta URL y pégala en la configuración de retorno de tu botón de PayPal. Se basa en el 'Nombre interno' del plan." className="cursor-help text-gray-400">
          <HelpCircle size={16} />
        </span>
      </div>
      <div className="flex gap-2">
        <input 
          readOnly 
          className="border rounded-md px-3 py-2 w-full bg-gray-50 text-gray-500 font-mono text-xs dark:bg-slate-900 dark:border-slate-700 dark:text-gray-400 focus:outline-none" 
          value={url} 
          onClick={(e) => e.currentTarget.select()}
        />
        <button 
          type="button" 
          onClick={onCopy}
          className="px-3 py-2 rounded-md bg-gray-100 text-gray-700 hover:bg-gray-200 border border-gray-200 flex items-center gap-2 transition-colors dark:bg-slate-800 dark:border-slate-700 dark:text-gray-300 dark:hover:bg-slate-700 min-w-[100px] justify-center"
          title="Copiar URL"
        >
          {copied ? <Check size={16} className="text-green-600" /> : <Copy size={16} />}
          <span className="text-sm font-medium">{copied ? 'Copiado' : 'Copiar'}</span>
        </button>
      </div>
      <p className="text-xs text-gray-500 dark:text-gray-400">
        Esta URL se genera automáticamente basada en el <strong>Nombre interno</strong>. Úsala en el campo "return" de tu botón de PayPal.
      </p>
    </div>
  );
};
